import { FormProps } from 'react-final-form';

import { Offer_Visible_Status } from '@occc/graphql';

export enum EligibilityType {
  Eligible = 'eligible',
  NotEligible = 'notEligible',
}

export enum SourceFilterSelectOptionValueType {
  Reward = 'reward',
  Promotion = 'promotion',
  OfferChallenge = 'offerChallenge',
  Punchcard = 'punchcard',
  Awards = 'awards',
  Sweepstakes = 'sweepstakes',
  Games = 'games',
  Billboards = 'billboards',
}

export type EngagementType = SourceFilterSelectOptionValueType | 'any';
export type Eligibility = EligibilityType | 'any';
export type VisibleStatus = Offer_Visible_Status | 'any';

export type SourceFilterSelectOption = {
  label: string;
  value: EngagementType;
};

export type EligibilityFilterSelectOption = {
  label: string;
  value: Eligibility;
};

export type StatusFilterSelectOption = {
  label: string;
  value: VisibleStatus;
};

export type OffersFilterFormValues = {
  engagementType: EngagementType;
  eligibility: Eligibility;
  visibleStatus: VisibleStatus;
};

export type OffersFilterFormProps = {
  onSubmit: FormProps<OffersFilterFormValues>['onSubmit'];
  onReset: () => void;
  initialValues: OffersFilterFormValues;
};
